import { ebusinessDashboard } from '@demant/mybusiness';
ebusinessDashboard('.ebusiness-dashboard');